import styled from 'styled-components/macro';

interface Props {
    children: JSX.Element;
    id?: string;
}

export const SelectArea = (props: Props) => {
    return <S_SelectArea id={props.id}>{props.children}</S_SelectArea>;
};

const S_SelectArea = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
`;
